import { useState } from "react";
import { Selector } from "../Selector";
import { CloseIcon } from "./icons/CloseIcon";
import { DropDownIcon } from "./icons/DropDownIcon";
import styles from "./styles/Selectors.module.css";

export const Selectors = ({
  navigation,
  product,
  options,
  handleNavigationChange,
  handleOptionChange,
  openSizeGuide,
}) => {
  const [showColors, setShowColors] = useState(false);
  const [showSizes, setShowSizes] = useState(false);

  const selectedColour = navigation.find((item) => item.selected).labelText;
  const selectedSize = options.get("Size").find((item) => item.selected).labelText;
  const hasMultipleSizes = options.get("Size").map((item) => item).length > 1;

  const toggleColors = (e) => {
    e.preventDefault();
    if (showSizes) setShowSizes(false);
    setShowColors(!showColors);
  };

  const toggleSizes = (e) => {
    e.preventDefault();
    if (showColors) setShowColors(false);
    setShowSizes(!showSizes);
  };

  const ColorDrawer = () => {
    return (
      <div className={styles.drawer}>
        <button onClick={() => setShowColors(false)} className={styles.close}>
          <CloseIcon />
        </button>
        {navigation && navigation.length > 1 && (
          <Selector
            data={navigation}
            heading={"Colour"}
            name={"colour"}
            updateVariant={handleNavigationChange}
          />
        )}
      </div>
    );
  };

  const SizeDrawer = () => {
    return (
      <div className={styles.drawer}>
        <button onClick={() => setShowSizes(false)} className={styles.close}>
          <CloseIcon />
        </button>
        {Array.from(options.keys()).map((key) => {
          if (options.get(key).length > 1) {
            return (
              <Selector
                key={key.toLowerCase()}
                name={key.toLowerCase()}
                data={Array.from(options.get(key).values())}
                heading={key}
                updateVariant={handleOptionChange}
                openSizeGuide={openSizeGuide}
              />
            );
          }
        })}
      </div>
    );
  };

  return (
    <section className={styles.container}>
      <button onClick={toggleColors} className={styles.button}>
        {selectedColour ?? "Colour"}
        <DropDownIcon />
      </button>

      {hasMultipleSizes && (
        <button onClick={toggleSizes} className={styles.button}>
          {selectedSize ?? "Size"}
          <DropDownIcon />
        </button>
      )}

      {showColors && <ColorDrawer />}
      {showSizes && <SizeDrawer />}
    </section>
  );
};
